import { useEffect } from "react";
import { USER_INFO_KEY } from "../constants/common";
import { SSO_PROVIDERS } from "../helpers/crossLoginHelper";

const parseUserInfo = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const isSSOSession = (parsed) => {
  const provider = parsed?.token?.providerLogin;
  return SSO_PROVIDERS.includes(provider);
};

const useSSOCrossTabSync = () => {
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key !== USER_INFO_KEY) return;

      const oldSession = parseUserInfo(e.oldValue);
      const newSession = parseUserInfo(e.newValue);

      const oldUserId = oldSession?.userInfo?.userId;
      const newUserId = newSession?.userInfo?.userId;

      if (oldUserId === newUserId) return;

      if (isSSOSession(oldSession) || isSSOSession(newSession)) {
        window.location.reload();
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);
};

export default useSSOCrossTabSync;
